import React from 'react';
import PropTypes from 'prop-types';
import {css} from 'aphrodite';
import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

/**
 * ToolTipCell is used to display a tooltip when hoving the mouse over the `placeholder`.
 *
 * props parameters:
 * @param {object|string} placeholder html fragment or text to hover over to display tooltip.
 * @param {string}        text        text to display in the tooltip.
 * @param {string}        id          id property for the tooltip.
 * @param {string}        placement   where to place the tooltip, 'top', 'bottom', 'right' or 'left'.
 * @param {object}        styleSheet  (Optional) If provided, must contain tooltip attribute, which contains the css for the tooltip.
 *
 * @returns ToolTipCell component
 */
export const ToolTipCell = ({
  placeholder,
  text,
  id,
  placement,
  styleSheet,
}) =>  {
  if (!text) {
    return (<span>{placeholder}</span>);
  }

  const tooltip = <Tooltip id={id} className={styleSheet ? css(styleSheet.tooltip) : ''}>{text}</Tooltip>;

  return (
    <OverlayTrigger
      overlay={tooltip}
      placement={placement}
      delayShow={150}
      delayHide={150}
    >
      <span>{placeholder}</span>
    </OverlayTrigger>
  );
}

ToolTipCell.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  placement: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  styleSheet: PropTypes.object,
};

ToolTipCell.defaultProps = {
  placement: 'top',
};

export default ToolTipCell;
